import React from "react";

import {
  FiCalendar,
  FiCheck,
  FiEye,
  FiX,
  FiXCircle,
} from "react-icons/fi";

import {
  FaSpinner,
} from "react-icons/fa";

import EmployeePagination
  from "../common/EmployeePagination";

import EmployeeStatusBadge
  from "../common/EmployeeStatusBadge";

import {
  formatEmployeeDate,
} from "../utils/employee.utils";

import "./EmployeeLeave.css";


const EmployeeLeaveTable = ({
  leaves = [],

  loading = false,

  page = 1,

  limit = 10,

  totalRecords = 0,

  totalPages = 1,

  onPageChange,

  onLimitChange,

  onView,

  onApprove,

  onReject,

  onCancel,
}) => {

  if (
    loading
  ) {

    return (

      <div className="employee-leave-loading">

        <FaSpinner />

        <span>
          Loading leave records...
        </span>

      </div>

    );

  }


  return (

    <section className="employee-leave-table-card">

      <div className="employee-leave-table-heading">

        <div>

          <span>
            LEAVE REQUESTS
          </span>

          <h2>
            Employee Leaves
          </h2>

          <p>
            Review employee leave requests and approval status.
          </p>

        </div>

      </div>


      <div className="employee-leave-table-scroll">

        <table className="employee-leave-table">

          <thead>

            <tr>

              <th>#</th>

              <th>
                Employee
              </th>

              <th>
                Leave Type
              </th>

              <th>
                From
              </th>

              <th>
                To
              </th>

              <th>
                Days
              </th>

              <th>
                Paid
              </th>

              <th>
                Status
              </th>

              <th>
                Actions
              </th>

            </tr>

          </thead>


          <tbody>

            {
              leaves.length ===
              0
                ?
                (
                  <tr>

                    <td
                      colSpan="9"
                      className="employee-leave-empty"
                    >

                      <FiCalendar />

                      <strong>
                        No leave records found
                      </strong>

                      <span>
                        Leave requests will appear here.
                      </span>

                    </td>

                  </tr>
                )
                :
                leaves.map(
                  (
                    leave,
                    index
                  ) => {

                    const employee =
                      leave?.employeeId &&
                      typeof leave.employeeId ===
                        "object"
                        ?
                        leave.employeeId
                        :
                        leave?.employee ||
                        {};


                    const leaveType =
                      leave?.leaveTypeId &&
                      typeof leave.leaveTypeId ===
                        "object"
                        ?
                        leave.leaveTypeId
                        :
                        leave?.leaveType ||
                        {};


                    const status =
                      String(
                        leave?.status ||
                        "PENDING"
                      )
                        .toUpperCase();


                    const pending =
                      status ===
                      "PENDING";


                    const approved =
                      status ===
                      "APPROVED";


                    return (

                      <tr
                        key={
                          leave?._id ||
                          index
                        }
                      >

                        <td>
                          {
                            (
                              Number(
                                page
                              ) -
                              1
                            ) *
                            Number(
                              limit
                            ) +
                            index +
                            1
                          }
                        </td>


                        <td>

                          <div className="employee-leave-person">

                            <strong>
                              {
                                employee?.name ||
                                leave?.employeeName ||
                                "-"
                              }
                            </strong>

                            <span>
                              {
                                employee?.employeeCode ||
                                leave?.employeeCode ||
                                "-"
                              }
                            </span>

                          </div>

                        </td>


                        <td>

                          <strong>
                            {
                              leaveType?.name ||
                              leave?.leaveTypeName ||
                              "-"
                            }
                          </strong>

                        </td>


                        <td>
                          {
                            formatEmployeeDate(
                              leave?.fromDate ||
                              leave?.startDate
                            )
                          }
                        </td>


                        <td>
                          {
                            formatEmployeeDate(
                              leave?.toDate ||
                              leave?.endDate
                            )
                          }
                        </td>


                        <td>

                          <strong>
                            {
                              Number(
                                leave?.totalDays ??
                                leave?.days ??
                                0
                              )
                            }
                          </strong>

                        </td>


                        <td>

                          <span
                            className={
                              leave?.isPaid
                                ?
                                "employee-leave-paid"
                                :
                                "employee-leave-unpaid"
                            }
                          >

                            {
                              leave?.isPaid
                                ?
                                "Paid"
                                :
                                "Unpaid"
                            }

                          </span>

                        </td>


                        <td>

                          <EmployeeStatusBadge
                            status={
                              status
                            }
                          />

                        </td>


                        <td>

                          <div className="employee-leave-actions">

                            <button
                              type="button"
                              onClick={
                                () =>
                                  onView?.(
                                    leave
                                  )
                              }
                              title="View"
                            >

                              <FiEye />

                            </button>


                            <button
                              type="button"
                              className="employee-leave-approve-action"
                              onClick={
                                () =>
                                  onApprove?.(
                                    leave
                                  )
                              }
                              disabled={
                                !pending
                              }
                              title="Approve"
                            >

                              <FiCheck />

                            </button>


                            <button
                              type="button"
                              className="employee-leave-reject-action"
                              onClick={
                                () =>
                                  onReject?.(
                                    leave
                                  )
                              }
                              disabled={
                                !pending
                              }
                              title="Reject"
                            >

                              <FiX />

                            </button>


                            <button
                              type="button"
                              className="employee-leave-cancel-action"
                              onClick={
                                () =>
                                  onCancel?.(
                                    leave
                                  )
                              }
                              disabled={
                                ![
                                  "PENDING",
                                  "APPROVED",
                                ].includes(
                                  status
                                )
                              }
                              title="Cancel"
                            >

                              <FiXCircle />

                            </button>

                          </div>

                        </td>

                      </tr>

                    );

                  }
                )
            }

          </tbody>

        </table>

      </div>


      {
        totalRecords >
        0
          ?
          (
            <EmployeePagination
              page={
                page
              }
              limit={
                limit
              }
              totalRecords={
                totalRecords
              }
              totalPages={
                totalPages
              }
              onPageChange={
                onPageChange
              }
              onLimitChange={
                onLimitChange
              }
            />
          )
          :
          null
      }

    </section>

  );

};


export default EmployeeLeaveTable;